import { SpwkUtil } from "../dao/SpwkUtil";
import { UniAnswer } from "../dao/UniAnswer";
import { UniAnswerDAO } from "../dao/UniAnswerDAO";
import { UniForm } from "../dao/UniForm";
import { UniFormDAO } from "../dao/UniFormDAO";
import { UniInputDAO } from "../dao/UniInputDAO";
import { UniOptionDAO } from "../dao/UniOptionDAO";
import { UniQuestion } from "../dao/UniQuestion";
import { UniQuestionDAO } from "../dao/UniQuestionDAO";
import { ExportBundle } from "./ExportBundle";
import { ExportNormalizor } from "./ExportNormalizor";
import { GovRowHelper } from "./GovRowHelper";
import { HisBasic } from "./HisBasic";
import { HisBasicParser_基本檔 } from "./HisBasicParser_基本檔";
import { HisRow } from "./HisRow";
import { HisRowHelper } from "./HisRowHelper";
import { SpwkMetaData } from "./SpwkMetaData";
import { SpwkMetaTable } from "./SpwkMetaTable";

/**
 * 實際轉檔是靠這兩行:
 *   const { 基本檔, 資料行列表 } = HisRowHelper.ConvertToHIS格式(作業編號, ans, MetaTable);
 *   const HIS申報資料行列表 = GovRowHelper.ConvertTo申報格式(MetaTable);
 */
export class ExportManager {

  static async 批次轉為資訊匯入格式(project_guid: string, member_guid_list: string[]) {

    try {
      let project_answer_list = await UniAnswerDAO.Select_指定場次的特作答案列表(project_guid);
      // FIXME 可以不用全部撈出來，只撈 member_guid_list 有的就好

      let { cache_answer_list, base_form_guid_list, spwk_form_guid_list } = ExportManager.取得Base與Spwk的GuidList(project_answer_list, member_guid_list);

      if (base_form_guid_list.length === 0 || spwk_form_guid_list.length === 0) {
        throw new_ErrorAlert("464131384 應該要有 form_guid !!!");
      }

      let { base_form_list, spwk_form_list } = await ExportManager.GetForms_AndFillTree_Async(base_form_guid_list, spwk_form_guid_list);

      let rslt: [ExportBundle[], UniAnswer[], string[]] = ExportManager.RunBatchExport(cache_answer_list, base_form_list, spwk_form_list);

      console.log("rslt", rslt);




    } catch (error: any) {
      throw new_ErrorAlert("684674 轉入HIS失敗: " + error.message);
    }

  }





  static async GetForms_AndFillTree_Async(base_form_guid_list: string[], spwk_form_guid_list: string[]): Promise<{ base_form_list: UniForm[], spwk_form_list: UniForm[] }> {
    /* 先混合一起建立樹狀圖 */
    let form_guid_list = [...base_form_guid_list, ...spwk_form_guid_list];

    /* 為了減少 Select 次數，將所有相關的資料一次撈出來，之後再用 .filter() 重新分配 */
    const cache_forms = await UniFormDAO.WS_SelectForms_ByFormGuidList(form_guid_list);
    const cache_questions = await UniQuestionDAO.WS_SelectQuestions_ByFormGuidList(form_guid_list);
    const cache_options = await UniOptionDAO.WS_SelectOptions_ByFormGuidList(form_guid_list);
    const cache_inputs = await UniInputDAO.DB_SelectInputs_ByFormGuidList(form_guid_list);

    /* 填好樹狀結構 $$$ 核心方法 */
    UniFormDAO.FillFormTree(cache_forms, cache_questions, cache_options, cache_inputs);

    /* 重新拆分後返回 */
    let base_form_list = cache_forms.filter(x => base_form_guid_list.includes(x.guid));
    let spwk_form_list = cache_forms.filter(x => spwk_form_guid_list.includes(x.guid));

    return { base_form_list, spwk_form_list };
  }

  private static 取得Base與Spwk的GuidList(project_answer_list: UniAnswer[], member_guid_list: string[])
    : { cache_answer_list: UniAnswer[], base_form_guid_list: string[]; spwk_form_guid_list: string[]; } {

    let cache_answer_list: UniAnswer[] = [];
    let base_form_guid_list: string[] = [];
    let spwk_form_guid_list: string[] = [];

    for (const member_guid of member_guid_list) {
      const finds = project_answer_list.filter(x => x.member_guid === member_guid);

      if (finds.length != 1) {
        throw new_ErrorAlert("864531: 應該要剛好有唯一的一筆Answer!!! member_guid:" + member_guid);
      }

      const ans = finds[0];
      cache_answer_list.push(ans);
      base_form_guid_list.push(ans.base_form_guid);
      spwk_form_guid_list = spwk_form_guid_list.concat(ans.getSpwkFormGuidList());
    }

    // 不重複的
    base_form_guid_list = base_form_guid_list.filter((value, index, self) => self.indexOf(value) === index);
    spwk_form_guid_list = spwk_form_guid_list.filter((value, index, self) => self.indexOf(value) === index);
    return { cache_answer_list, base_form_guid_list, spwk_form_guid_list };
  }

  /** 批次產生匯出資料:  
   * 外部的呼叫者把所有相關的資料都準備好，一次性進行轉檔  
   * 注意! 以下Form必須都填好樹狀結構 Form->Questions->Options->Inputs
   * 
   * @param CACHE_ANSWER_LIST - 需要轉檔的 Answers，每個 Ans 可能包含多個特作問卷
   * @param CACHE_BASE_FORM_LIST - 以上 Answers 會用到的所有通用基礎問題
   * @param CACHE_SPWK_FORM_LIST - 以上 Answers 會用到的所有特作問卷定義
   * 
   * return [轉出結果, 失敗答案列表, 錯誤訊息列表]
   */
  static RunBatchExport(CACHE_ANSWER_LIST: UniAnswer[], CACHE_BASE_FORM_LIST: UniForm[], CACHE_SPWK_FORM_LIST: UniForm[])
    : [ExportBundle[], UniAnswer[], string[]] {

    let FailedAnswers: UniAnswer[] = [];// 失敗的問卷累績
    let ErrorMessages: string[] = [];

    let re: ExportBundle[] = [];// OK的匯出結果

    for (const ans of CACHE_ANSWER_LIST) {// 對所有 Answer

      try {
        const relate_spwk_form_guids = ans.getSpwkFormGuidList();// 此合併問卷包含哪些特作

        const find_base_form = CACHE_BASE_FORM_LIST.find(x => x.guid === ans.base_form_guid);// 找出通用題目
        const relate_spwk_forms = CACHE_SPWK_FORM_LIST.filter(x => relate_spwk_form_guids.includes(x.guid));

        // $$$ 處理單一受檢者的匯出
        const single_export_bundle = ExportManager.RunExportOneAnswer(ans, find_base_form, relate_spwk_forms);

        // TODO 也可以考慮在此用API 與 資訊介接

        if (single_export_bundle == null) {
          ErrorMessages.push("null 轉檔失敗!!!");
          FailedAnswers.push(ans);// 失敗! 記錄下來
          continue;
        }

        re.push(single_export_bundle);
      } catch (ex: any) {
        ErrorMessages.push((ex as Error).message);
        FailedAnswers.push(ans);// 失敗! 記錄下來
      }

    }

    return [re, FailedAnswers, ErrorMessages];
  }



  /**
   * 產生單一受檢者的問卷匯出資料
   */
  static RunExportOneAnswer(ans: UniAnswer, cache_base_form: UniForm | undefined, cache_spwk_forms: UniForm[]): ExportBundle | null {

    /* $$$ 產生此受檢者，各特作的中繼表，並先簡單填上 rhf_value */
    const meta_table_list: SpwkMetaTable[] = ExportManager.GetMetaTable_and_FillRhfValue(ans, cache_base_form, cache_spwk_forms);

    //#region 可以在此回傳 DEBUG(看看中繼表)
    // alert("DEBUG 54343135");
    // let re = new ExportBundle();
    // for (const meta_table of meta_table_list) {
    //   re.AllMetaDataList = re.AllMetaDataList.concat(meta_table.meta_rows);
    // }
    // return re;
    //#endregion

    /* $$$ 看著手上的數值資料，將數值合理化 (其他:_____、無...)  (變為如果不合併，受檢者應該會這樣填寫答案) */
    ExportNormalizor.RunNormalization(meta_table_list);

    /* $$$ 開始轉檔 */
    let re: ExportBundle = ExportManager.ConvertTo_ExportBundle(ans, meta_table_list);

    return re;
  }



  static GetMetaTable_and_FillRhfValue(ans: UniAnswer, cache_base_form: UniForm | undefined, cache_spwk_forms: UniForm[]): SpwkMetaTable[] {

    const relate_spwk_form_guids = ans.getSpwkFormGuidList();
    const re: SpwkMetaTable[] = [];

    //#region step1. 產生基礎中繼檔格式，並先簡單填入 RHF 答案
    for (const form_guid of relate_spwk_form_guids) {
      const find_spwk_form = cache_spwk_forms.find(x => x.guid === form_guid);

      if (cache_base_form == null || find_spwk_form == null) {
        let err_msg = "`" + form_guid + "` 的資料不完整，無法匯出!!!";
        alert(err_msg);
        throw new Error(err_msg);
      }

      // $$$ 先把一個特作轉為空白中繼表
      const a_meta_table: SpwkMetaTable = ExportManager.ConvertTo_BlankMetaTable(cache_base_form, find_spwk_form);// 轉成Table格式

      // $$$ 依照中繼表，把 RHF 答案原封不動的填上(先不管 其他、無... 合理性)
      ExportManager.FillRhfValue_ToMetaTable(a_meta_table, ans);// 將 Answer 填到對應的 Value 欄位

      // mFormGuid_x_MetaTable[form_guid] = a_meta_table;// 先記錄起來備用
      re.push(a_meta_table);
    }
    //#endregion

    return re;
  }

  static ConvertTo_ExportBundle(ans: UniAnswer, meta_table_list: SpwkMetaTable[]) {
    //#region step3. 看著填好完整答案，的中繼資料(格式同職安屬原始Word)，依照規則產出 HIS格式 與 申報格式
    let re = new ExportBundle();// 單人，xN張特作 的 累積轉檔結果

    re.SourceUniAnswer = ans;// $$$ 記憶轉檔來源

    const relate_spwk_form_guids = ans.getSpwkFormGuidList();
    for (const form_guid of relate_spwk_form_guids) {

      const meta_table = meta_table_list.find(x => x.form_guid === form_guid);

      if (meta_table == null) {
        throw new_ErrorAlert("找不到對應的 form_guid: " + form_guid + " !!!");
      }

      let func_code = meta_table.func_code;
      let func_guid = meta_table.func_guid;

      // 1: 轉出 基本檔 與 特作行
      const { his_basic /*基本檔*/, his_row_list /*特作行*/ } = ExportManager.ConvertTo_基本檔_and_特作行(func_guid, func_code, ans, meta_table);

      // 2. 轉出: 申報行
      const gov_row_list = GovRowHelper.ConvertTo申報格式(func_guid, func_code, his_basic, meta_table);

      //------------------------------------------------------------------------ 
      re.AllMetaDataList = re.AllMetaDataList.concat(meta_table.meta_rows);

      re.AllHisBasicList = re.AllHisBasicList.concat(his_basic);
      re.AllHisRowList = re.AllHisRowList.concat(his_row_list);

      re.AllGovRowList = re.AllGovRowList.concat(gov_row_list);
    }
    //#endregion

    // --------------------------- 至此, 已完成轉檔 (單一受檢者的N張)

    return re;
  }

  /** 轉換為 His匯出格式
     *
     * @param func_code - 特作代碼(A01、A98、B02...) 由外部指定
     * @param ans - 有些數值 要馬上反查此答案取得
     * @param meta_table - 大部分數值由此中繼表取得   * 
     */
  static ConvertTo_基本檔_and_特作行(func_guid: string, func_code: string, ans: UniAnswer, meta_table: SpwkMetaTable): { his_basic: HisBasic, his_row_list: HisRow[] } {

    if (meta_table.IsAllSameFuncCode(func_code) === false) {
      let err_msg = "1657411: 轉檔失敗! 必須放入單一特作的資料";
      alert("1657411: 轉檔失敗! 必須放入單一特作的資料");
      throw new Error(err_msg);
    }

    // 轉檔: 基本檔(問卷基本檔.xlsx)
    const his_basic: HisBasic = HisBasicParser_基本檔.__ConvertTo_基本檔(func_code, ans, meta_table);

    // 轉檔: 特作行
    const his_row_list: HisRow[] = HisRowHelper.__ConvertTo_特作行(func_guid, func_code, ans, meta_table, his_basic);

    return { his_basic, his_row_list };

  }





  /** 填好中繼表.rhf_value 欄位 
   * 只填原始數值，不特別處理合理性(其他、無... 等問題)
  */
  static FillRhfValue_ToMetaTable(meta_table: SpwkMetaTable, ans: UniAnswer) {
    const rhf_data = ans.ConvertToSpwkRhfData();

    for (const meta of meta_table.meta_rows) {
      if (meta.rhf_name != null && meta.rhf_name !== '') {
        meta.rhf_value = meta.GetRhfValue(rhf_data);// SpwkMetaDataHelper.GetRhfValue(rhf_data, meta.rhf_name);
      }
    }
  }


  /**
  * 匯出時總是依照此章節順序(基本上與職安屬Word相同)
  */
  static CHAPTER_LIST = [
    SpwkUtil.CHAPTER_基本資料,
    SpwkUtil.CHAPTER_檢查時期,
    SpwkUtil.CHAPTER_作業經歷,

    SpwkUtil.CHAPTER_既往病史,
    SpwkUtil.CHAPTER_既往病史_噪音作業,

    SpwkUtil.CHAPTER_生活習慣,

    SpwkUtil.CHAPTER_自覺症狀,
    SpwkUtil.CHAPTER_自覺症狀_噪音作業,

    SpwkUtil.CHAPTER_疲勞狀況,

    SpwkUtil.CHAPTER_環境監測,
  ];


  /**
   * 產生空白的 中繼資料表(大總表)
   * 樹狀圖打平: Form->Question->Option->Input 變為單一層結構
   */
  static ConvertTo_BlankMetaTable(base_form: UniForm, spwk_form: UniForm): SpwkMetaTable {

    const re: SpwkMetaTable = new SpwkMetaTable(base_form, spwk_form);

    const func_code = spwk_form.func_code ?? "";

    re.pushMetaData(new SpwkMetaData(func_code, spwk_form));// Add Form

    for (const chapter of ExportManager.CHAPTER_LIST) {

      // 684616: 注意此處 Questions 的準確度 (最後重新再看過一次)
      let questions: UniQuestion[] = SpwkUtil.GetChapterQuestions(chapter, base_form, [spwk_form], [spwk_form.func_guid]);

      questions = questions.filter(x => x.v3_mode === 0);// 在此先移除 v3_mode 用來合併的大標題

      for (const question of questions) {
        re.pushMetaData(new SpwkMetaData(func_code, question));// Add Question

        if (question.Options == null) {
          continue;
        }

        for (const option of question.Options) {
          re.pushMetaData(new SpwkMetaData(func_code, option));// Add Option

          if (option.Inputs == null) {
            continue;
          }

          for (const input of option.Inputs) {
            re.pushMetaData(new SpwkMetaData(func_code, input));// Add Input
          }

        }
      }

    }

    return re;

  }



}

export function new_ErrorAlert(err_msg: string): Error {
  alert(err_msg);
  // console.log(err_msg)
  return new Error(err_msg);
}
